import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

const PATH_TEMPLATE = '/questionnaires/{questionnaireId}/pdf-fill-json/all';
type ThisApi = ApiDefinition[typeof PATH_TEMPLATE]['GET'];
type Input = ThisApi['params'];

const getAllPdfFillJsons = async ({ questionnaireId }: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>(PATH_TEMPLATE, {
    questionnaireId,
  });
  const response = await formsBackendClient.get(path);
  return response.data;
};

export default getAllPdfFillJsons;
